var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-overlay',{attrs:{"value":_vm.$store.state.isLoading}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"100"}},[_vm._v("Please wait...")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }